import { render } from "./letter-forward.vue?vue&type=template&id=e86c56fe"
import script from "./letter-forward.vue?vue&type=script&lang=js"
export * from "./letter-forward.vue?vue&type=script&lang=js"

import "./letter-forward.vue?vue&type=style&index=0&id=e86c56fe&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__